/**
 * Whether an error is a request the app cancelled itself, so the automatic
 * bug report can tell a deliberate cancel from a failure.
 *
 * Aborting an `AbortController` rejects its fetch with a `DOMException` named
 * `AbortError` (the signal's default reason). The Advanced Search hook aborts
 * a search when the modal closes, when its results are cleared, and when a new
 * search replaces it; each of those is the operator's own action.
 *
 * Matched on the NAME, not the class: the DOMException and an Error subclass
 * named `AbortError` both mean a cancelled request. `AbortSignal.timeout()`
 * rejects with `TimeoutError`, which is a failure and is kept.
 */
export function isAbortedRequest(err: unknown): boolean {
  return typeof err === 'object' && err !== null
    && (err as { name?: unknown }).name === 'AbortError';
}
